var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5417 47.9167C12.7083 47.9167 11.9792 47.6042 11.3542 46.9792C10.7292 46.3542 10.4167 45.625 10.4167 44.7917V5.20834C10.4167 4.37501 10.7292 3.64584 11.3542 3.02084C11.9792 2.39584 12.7083 2.08334 13.5417 2.08334H36.4583C37.2917 2.08334 38.0208 2.39584 38.6458 3.02084C39.2708 3.64584 39.5833 4.37501 39.5833 5.20834V44.7917C39.5833 45.625 39.2708 46.3542 38.6458 46.9792C38.0208 47.6042 37.2917 47.9167 36.4583 47.9167H13.5417ZM13.5417 43.2292V44.7917H36.4583V43.2292H13.5417ZM13.5417 40.1042H36.4583V9.89584H13.5417V40.1042ZM13.5417 6.77084H36.4583V5.20834H13.5417V6.77084ZM13.5417 6.77084V5.20834V6.77084ZM13.5417 43.2292V44.7917V43.2292Z",
    fill: "#5D5FEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f766e58cfa1ce9c549f9db98e797d68c.svg";
export { ForwardRef as ReactComponent };